import { Apple, Monitor } from 'lucide-react'

const OPTIONS = [
  { id: 'mac', label: 'Mac', Icon: Apple },
  { id: 'windows', label: 'Windows', Icon: Monitor },
]

/**
 * Asks which machine the trainee is on. State lives in `usePlatform`
 * (src/lib/platform.js) so this file exports only components.
 */
export default function PlatformPicker({ platform, onChange, prompt = 'Which machine are you on?' }) {
  return (
    <div className="rounded-xl border-2 border-slate-200 bg-white p-5">
      <p className="mb-3 text-sm font-semibold text-slate-700">{prompt}</p>
      <div className="flex flex-wrap gap-3">
        {OPTIONS.map((option) => (
          <button
            key={option.id}
            onClick={() => onChange(option.id)}
            className={`inline-flex items-center gap-2 rounded-lg border-2 px-5 py-2.5 text-sm font-medium transition-colors ${
              platform === option.id
                ? 'border-indigo-500 bg-indigo-50 text-indigo-800'
                : 'border-slate-200 text-slate-600 hover:border-indigo-300 hover:bg-slate-50'
            }`}
          >
            <option.Icon className="h-4 w-4" />
            {option.label}
          </button>
        ))}
      </div>
      {!platform && (
        <p className="mt-3 text-sm text-slate-500">
          Pick one and the rest of this module will show you only the steps that apply to you.
        </p>
      )}
    </div>
  )
}

/** Renders `mac` or `windows` content, prompting for the platform if unset. */
export function ForPlatform({
  platform,
  mac,
  windows,
  unsetMessage = 'Choose your machine above to see the right steps.',
}) {
  if (!platform) {
    return (
      <div className="rounded-lg border border-dashed border-slate-300 bg-slate-50 px-4 py-3 text-sm text-slate-500">
        {unsetMessage}
      </div>
    )
  }
  return <>{platform === 'mac' ? mac : windows}</>
}
